import {Injectable} from "@angular/core";
import {
  Geolocation,
  GeolocationOptions,
  Geoposition,
} from "@ionic-native/geolocation";
import {Observable} from "rxjs";

@Injectable()
export class GeolocationNative {

  constructor(
    private geolocation: Geolocation,
  ) {
  }

  getCurrentPosition(options?: GeolocationOptions): Promise<Geoposition> {
    return this.geolocation.getCurrentPosition(options);
  }

  watchPosition(options?: GeolocationOptions): Observable<Geoposition> {
    return this.geolocation.watchPosition(options);
  }
}



// WEBPACK FOOTER //
// ./src/native/geolocation.native.ts